import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/backToHome.svg'
import _imports_1 from '@/assets/general/icloud.svg'


const _withScopeId = n => (_pushScopeId("data-v-1f623fae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icloud" }
const _hoisted_2 = { class: "tobind" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "back" }
const _hoisted_5 = { class: "topInfo" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "apple",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "please" }
const _hoisted_8 = { class: "details" }
const _hoisted_9 = { class: "centerInput" }
const _hoisted_10 = { class: "popover" }
const _hoisted_11 = { class: "form" }
const _hoisted_12 = {
  key: 0,
  class: "smallName"
}
const _hoisted_13 = {
  key: 0,
  class: "smallName"
}
const _hoisted_14 = {
  key: 2,
  class: "logining right-style"
}
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "bottomInfo" }

import { ref, reactive, watch, computed, onMounted } from "vue";
import { loginIcloud } from "@/api/ios";
import securityDialog from "./component/securityDialog.vue";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { gaEvent } from "@/utils/format";


export default /*#__PURE__*/_defineComponent({
  __name: 'icloudLogin',
  setup(__props) {

const { t } = useI18n();
const store = useStore();

// const vFocus = {
//     mounted: (el) => el.focus()
// }


const formData = reactive({
    UserName: "",
    // UserName: "tenor03@sina.com",
    UserPassword: "",
    isShowPassword: false,
    // 去掉谷歌回显
    readonly: true,

    // 当前username是否可输入
    userNameRead: true,

    // 当前校验是否正确
    incorrectEmail: false,
    incorrectPass: false,

    // 是否显示错误提示
    isShowPopover: false,

    showLoading: false,
});

const currentAppleId = computed(() => store.state.currentAppleId);

onMounted(() => {
    gaEvent("Binddevice_iOSGuide_View", {
        event_category: "AddDevice",
        event_label: "None",
    });
});

const handlerIptClick = () => {
    formData.readonly = false
}

const handlerNameClick = () => {
    if (!isExpiredLogin.value) {
        formData.userNameRead = false
    }
}


const showDialog = ref(false)
let router = useRouter();

watch(() => formData.UserName, (newV, oldV) => {
    if (newV !== '') {
        formData.incorrectEmail = false
        formData.incorrectPass = false
        formData.isShowPopover = false
    }
})

watch(() => formData.UserPassword, (newV, oldV) => {
    console.log('newV:::', newV);
    if (newV !== '') {
        formData.incorrectEmail = false
        formData.incorrectPass = false
        formData.isShowPopover = false
    }
})

const deviceList = computed(() => store.state.deviceInfo);
const isShowBack = computed(() => store.state.isShowBack);
const isExpiredLogin = computed(() => store.state.isExpiredLogin);

watch(isExpiredLogin, (newV, oldV) => {
    if (newV == '') {
        formData.UserName = ""
    } else {
        formData.UserName = currentAppleId.value
        formData.userNameRead = true
    }
}, {
    immediate: true
})

const goLogin = async () => {
    // 为空的情况，现在密码为空就不让点击，所以暂时无用
    // if (!formData.UserName && !formData.UserPassword) {
    //     formData.incorrectEmail = true
    //     formData.incorrectPass = true
    //     formData.isShowPopover = true
    //     return
    // } else if (!formData.UserName) {
    //     formData.incorrectEmail = true
    //     formData.isShowPopover = true
    //     return
    // } else if (!formData.UserPassword) {
    //     formData.incorrectPass = true
    //     formData.isShowPopover = true
    //     return
    // }

    if (formData.UserName == '' || formData.UserPassword == '') return

    formData.showLoading = true


    let params = {
        apple_id: formData.UserName,
        password: formData.UserPassword
    }


    try {
        const res = await loginIcloud(params)
        console.log('res', res);

        if (res.data.code == 200) {
            formData.showLoading = false
            await store.dispatch("getUserInfo");
            await store.dispatch("getDeviceInfo")
            console.log('deviceList.value', deviceList.value);
            for (const item of deviceList.value) {
                console.log('1', item);
                if (item.apple_id) {
                    console.log('item::::', item);
                    store.commit('setCurrentAppleId', item.apple_id)
                    store.commit(
                        "setCurrentDeviceId",
                        item.devices[0].id
                    );
                    store.commit(
                        "setCurrentDeviceInfo",
                        item.devices[0]
                    );
                    break;
                }
            }
            store.dispatch('updateMenuList')
            console.log('2');
            router.push("home");
        } else if (res.data.code == 401004) {
            // 需要双重验证
            console.log('here');
            showDialog.value = true
        } else if (res.data.code == 400201) {
            // 账号密码错误
            formData.incorrectEmail = true
            formData.incorrectPass = true
            formData.isShowPopover = true
            formData.showLoading = false
        } else if (res.data.code == 409002) {
            // 设备已被绑定
            ElMessage({
                message: t("famikeep210.The device has been bound to other account"),
                type: "error",
            });
        }
    } catch (err: any) {
        // 账号密码不正确
        formData.incorrectPass = true
        formData.incorrectEmail = true

        if (err.response) {
            console.log('err.response', err.response);

            if (err.response.data.code == 401004) {
                // 需要双重验证
                console.log('here');
                showDialog.value = true
            } else if (err.response.data.code == 400201) {
                // 账号密码错误
                formData.incorrectEmail = true
                formData.incorrectPass = true
                formData.isShowPopover = true
                formData.showLoading = false
            } else if (err.response.data.code == 409002) {
                // 设备已被绑定
                ElMessage({
                    message: t("famikeep210.The device has been bound to other account"),
                    type: "error",
                });
            }
        }
    } finally {
        formData.showLoading = false
    }
}

const closeDialog = () => {
    showDialog.value = false
    formData.showLoading = false
}

const goBackHome = () => {
    store.commit('setIsShowBack', false)
    store.commit('setIsExpiredLogin', false)
    router.push('home')
}

const jumpToForget = () => {
    // 忘记密码的跳转链接
    window.open(
        "https://cbs.famikeep.com/go?pid=7510&a=c1",
        "_blank"
    );
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (isShowBack.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "backToHome",
              onClick: goBackHome
            }, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('famikeep200.Back')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("famikeep210.Please bind your device")), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("famikeep210['Log in iCloud to binding.']")), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_popover, {
              placement: 'bottom',
              "popper-class": "cloudPopover",
              width: 300,
              visible: formData.isShowPopover
            }, {
              reference: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_el_form, {
                    class: "ruleForm",
                    model: formData,
                    ref: "ruleFormRef"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "",
                        prop: "UserName",
                        class: "username"
                      }, {
                        default: _withCtx(() => [
                          (formData.UserName)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Apple ID"))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_input, {
                            placeholder: _ctx.$t('famikeep210.Please enter your Apple ID'),
                            modelValue: formData.UserName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.UserName) = $event)),
                            onInput: _ctx.handleInput,
                            class: _normalizeClass(["setlist", [formData.UserName ? 'newpadding' : '', formData.incorrectEmail ? 'incorrect' : '']]),
                            autocomplete: "off",
                            readonly: formData.userNameRead,
                            onClick: handlerNameClick
                          }, null, 8, ["placeholder", "modelValue", "onInput", "readonly", "class"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "",
                        prop: "UserPassword",
                        class: "pass"
                      }, {
                        default: _withCtx(() => [
                          (formData.UserPassword)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('password')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_input, {
                            placeholder: _ctx.$t('famikeep210.Please enter your password'),
                            modelValue: formData.UserPassword,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.UserPassword) = $event)),
                            type: formData.isShowPassword ? 'text' : 'password',
                            autocomplete: "off",
                            readonly: formData.readonly,
                            onClick: handlerIptClick,
                            class: _normalizeClass([formData.UserPassword ? 'newpadding' : '', formData.incorrectPass ? 'incorrect' : ''])
                          }, null, 8, ["placeholder", "modelValue", "type", "readonly", "class"]),
                          (!formData.showLoading)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["goLogin right-style", formData.UserName && formData.UserPassword ? 'changeImg' : '']),
                                onClick: goLogin
                              }, null, 2))
                            : (_openBlock(), _createElementBlock("div", _hoisted_14))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("famikeep210['Your entered account or password is incorrect.']")), 1)
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ]),
          _createElementVNode("div", {
            class: "jump",
            onClick: jumpToForget
          }, _toDisplayString(_ctx.$t('famikeep210.Forgot Apple ID or password?')), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", null, "1. " + _toDisplayString(_ctx.$t('famikeep210.Ensure Apple ID and password')), 1),
          _createElementVNode("div", null, "2. " + _toDisplayString(_ctx.$t('famikeep210.Devices using the same iCloud account will be bound')), 1)
        ])
      ])
    ]),
    (showDialog.value)
      ? (_openBlock(), _createBlock(securityDialog, {
          key: 0,
          visible: showDialog.value,
          onCloseDialog: closeDialog,
          appleID: formData.UserName
        }, null, 8, ["visible", "appleID"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})